import { Html5Qrcode } from 'html5-qrcode';

class BarcodeScanner {
  private scanner: Html5Qrcode | null = null;

  async iniciar(onDetect: (codigo: string) => void): Promise<void> {
    const dialog = document.getElementById('scanner-dialog') as HTMLDialogElement;
    const status = document.getElementById('scanner-status');

    if (!dialog) throw new Error('Elementos do scanner não encontrados');

    dialog.showModal();

    if (status) status.textContent = 'Solicitando acesso à câmera...';

    // html5-qrcode precisa de um div, não <video> — substitui se necessário
    const containerId = 'scanner-video';
    const videoEl = document.getElementById(containerId);
    if (videoEl && videoEl.tagName === 'VIDEO') {
      const div = document.createElement('div');
      div.id = containerId;
      div.style.width = '100%';
      videoEl.replaceWith(div);
    }

    try {
      this.scanner = new Html5Qrcode(containerId);

      await this.scanner.start(
        { facingMode: 'environment' },
        { fps: 15, qrbox: { width: 280, height: 150 }, aspectRatio: 1.8 },
        (decodedText) => {
          console.log('✅ Código detectado:', decodedText);
          onDetect(decodedText);
          this.parar();
        },
        () => { /* erros de frame são normais durante o scan */ }
      );

      if (status) status.textContent = 'Posicione o código de barras na câmera';

    } catch (error: any) {
      console.error('Erro ao iniciar scanner:', error);
      if (status) status.textContent = `Erro ao acessar câmera: ${error?.message || error}`;
      this.parar();
      throw error;
    }
  }

  parar() {
    if (this.scanner) {
      this.scanner.stop()
        .catch(() => { /* ignorar erros ao parar */ })
        .finally(() => {
          this.scanner?.clear();
          this.scanner = null;
        });
    }

    const dialog = document.getElementById('scanner-dialog') as HTMLDialogElement;
    if (dialog?.open) dialog.close();
  }
}

export const barcodeScanner = new BarcodeScanner();
export default barcodeScanner;
